export const DEFAULT_SUB_BOTS = [
  "7000101487",
  "7000100141",
  "7000101914",
  "7000102362",
  "7000102275",
  "7000102035",
  "7000101996"
];

export const ERROR = {
  FORBIDEN_TO_USE: 101010
};
